import { render, staticRenderFns } from "./special_iframe.vue?vue&type=template&id=228711e0&scoped=true"
import script from "./special_iframe.vue?vue&type=script&lang=js"
export * from "./special_iframe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228711e0",
  null
  
)

export default component.exports